import React, { lazy, Suspense } from 'react';

const TemplateTipsPopover = lazy(() =>
  import(
    /* webpackChunkName: "template-tips-popovers" */ './TemplateTipsPopover'
  ),
);

export const LazyTemplateTipsPopover: React.FunctionComponent<{
  boardId: string;
  isInGallery: boolean;
  name: string;
  username: string;
  toggleAboutThisTemplate: () => void;
  toggleBackgroundSelector: () => void;
}> = ({
  boardId,
  isInGallery,
  name,
  username,
  toggleAboutThisTemplate,
  toggleBackgroundSelector,
}) => {
  return (
    <Suspense fallback={null}>
      <TemplateTipsPopover
        boardId={boardId}
        isInGallery={isInGallery}
        name={name}
        username={username}
        toggleAboutThisTemplate={toggleAboutThisTemplate}
        toggleBackgroundSelector={toggleBackgroundSelector}
      />
    </Suspense>
  );
};
